module.exports = __webpack_public_path__ + "img/service.87003030.jpg";